import {PrintOrder, ViewOrderItems} from 'app/features/orders/componentsv1'
import {orderFulfillmentStatusTypes, orderType} from 'app/features/orders/models'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {mapToViewOrderItemsModel} from 'app/features/orders/redux/order/helper'
import FulfillmentAction from '../../fulfillments/fulfillment/components/lineItems/FulfillmentAction'
import {FC, useMemo} from 'react'
import ViewFulfilledItems from '../../fulfillments/fulfillment/components/lineItems/ViewFulfilledItems'
import {deliveryTypes, appProfileTypes, paymentProviderTypes} from 'app/constant'
import {getAppProfile} from 'app/utilities'
import {CreateRefund} from '../../fulfillments/fulfillment/components/orderActions/components'

interface Props {
  orderItems: any[]
  viewOrder: ViewOrder
}

export const OrderItemsView: React.FC<Props> = ({orderItems, viewOrder}) => {
  const isPosPickup = useMemo(() => {
    return (
      viewOrder.orderType === orderType.pos &&
      viewOrder.orderDeliveryMethod === deliveryTypes.pickup
    )
  }, [viewOrder.orderDeliveryMethod, viewOrder.orderType])

  const fulFillableItems = useMemo(() => {
    return mapToViewOrderItemsModel(orderItems, 'fulfillableQuantity')
  }, [orderItems])

  const posFulfilledItems = useMemo(() => {
    let items = orderItems
    if (viewOrder.fulfillments && viewOrder.fulfillments.length > 0) {
      items = mapToPosViewOrderItem(viewOrder.fulfillments[0].fulfillmentItems.nodes, orderItems)
    }
    return mapToViewOrderItemsModel(items, 'quantity')
  }, [orderItems, viewOrder.fulfillments])

  if (viewOrder.fulfillmentStatus === orderFulfillmentStatusTypes.restocked) {
    return (
      <ViewOrderItems
        items={mapToViewOrderItemsModel(orderItems, 'refundedQuantity')}
        title='Restocked Items'
      />
    )
  }

  return (
    <>
      {fulFillableItems.length > 0 && (
        <ViewOrderItems
          items={fulFillableItems}
          title={viewOrder.orderType === orderType.pos ? 'Shipping Unfulfilled' : 'Unfulfilled'}
          subTitle={
            viewOrder.invoiceNumber && (
              <span className='text-muted fw-bold text-muted d-block fs-7'>
                Invoice - # {viewOrder.invoiceNumber}
              </span>
            )
          }
        >
          <FulfillmentAction {...viewOrder} />
        </ViewOrderItems>
      )}
      {isPosPickup && viewOrder.orderType === orderType.pos && posFulfilledItems.length > 0 && (
        <ViewOrderItems
          items={posFulfilledItems}
          toolbar={
            <div className='d-flex align-items-center mb-3 gap-4'>
              <ButtonCreateRefund viewOrder={viewOrder} />
              <PrintOrder order={viewOrder} isPos />
            </div>
          }
          title='Fulfilled'
          subTitle={
            viewOrder.invoiceNumber && (
              <span className='text-muted fw-bold text-muted d-block fs-7'>
                Invoice - # {viewOrder.invoiceNumber}
              </span>
            )
          }
        />
      )}
      <ViewFulfilledItems viewOrder={viewOrder} isPosPickup={isPosPickup} />
    </>
  )
}

export default OrderItemsView

const mapToPosViewOrderItem = (fulfillmentItems: any, orderItems: any) => {
  return fulfillmentItems.map((fulfillmentItem: any) => {
    const correspondingOrderItem = orderItems.find(
      (orderItem: any) => orderItem.id === fulfillmentItem.orderItemId
    )

    let quantity = parseInt(fulfillmentItem.quantity)

    if (fulfillmentItem.refundedQuantity) {
      quantity -= parseInt(fulfillmentItem.refundedQuantity)
    }

    if (correspondingOrderItem) {
      return {
        ...fulfillmentItem,
        quantity,
        originalPrice: correspondingOrderItem.originalPrice,
      }
    }

    return {...fulfillmentItem, quantity}
  })
}

interface ButtonCreateRefundProps {
  viewOrder: ViewOrder
}

const ButtonCreateRefund: FC<ButtonCreateRefundProps> = ({viewOrder}) => {
  const appProfile = getAppProfile()
  if (
    (appProfile.type === appProfileTypes.pos || viewOrder.paymentProviderType === paymentProviderTypes.stripe) &&
    viewOrder &&
    viewOrder.fulfillments.length > 0 &&
    !viewOrder.isPosSplitOrder &&
    !viewOrder.isPaidByGiftCard
  ) {
    const fulfillment: any = viewOrder.fulfillments[0]
    return <CreateRefund fulfillmentId={fulfillment.id} />
  }
  return null
}
